export const AddAccessibleNavigationHandlers = () => {      
    const className = "attrax-child-nav-trigger";
    const allHasChildren: NodeListOf<HTMLElement> =
        document.querySelectorAll(".hasChildren");
    const navIcons: NodeListOf<HTMLElement> =
        document.querySelectorAll(".navList .icon");
    
    navIcons.forEach((icon: HTMLElement) => {
        icon.addEventListener("focus", () => {
            const isPartOfRootNav = icon?.closest(".navList")?.classList.contains("navRoot");

            if (isPartOfRootNav) {
                allHasChildren.forEach((hasChildren) => {
                    hasChildren.setAttribute("aria-expanded", "false");
                    hasChildren.classList.remove("attrax-child-nav-active");
                    handleTabIndexValueOfChildElements(hasChildren, "-1");
                });
            }

            icon.addEventListener("keydown", (event) => {
                const element = event.target as HTMLElement;
                const keystoke = event.key;


                if (
                    element.classList.contains(className) &&
                    (isSpacebar(keystoke) || isEnter(keystoke))
                ) {
                    event.preventDefault();
                    element
                        ?.closest(".hasChildren")
                        ?.classList.add("attrax-child-nav-active");
                    element
                        ?.closest(".hasChildren")
                        ?.setAttribute("aria-expanded", "true");
                    handleTabIndexValueOfChildElements(element, "0");
                }
            });
        });
    });
};

const isSpacebar = (keystoke: string): boolean => {
    return keystoke === " ";
};

const isEnter = (keystoke: string): boolean => {
    return keystoke === "Enter";
};

const handleTabIndexValueOfChildElements = (
    element: HTMLElement,
    index: "0" | "-1"
) => {
    const parent = element.closest(".hasChildren");
    const tabableElements = parent?.querySelectorAll(
        ".navList:not(.navRoot)>li a, .navList:not(.navRoot)>li .icon"
    );

    tabableElements?.forEach((el) => {
        el.setAttribute("tabindex", index);
    });
};


